const keys = {
  NAO: {
    key: 'NAO',
    description: 'Não',
  },
  SEMANALMENTE: {
    key: 'SEMANALMENTE',
    description: 'Semanalmente',
  },
};

const values = Object.keys(keys)
  .map((key) => keys[key]);

export default {
  keys,
  values,
};
